/* eslint-disable jsx-a11y/anchor-is-valid */
import cx from 'classnames';
import _ from 'lodash';
import React, { Children, useEffect } from 'react';
import { getOnEnter } from '../_utils';
import { BaseLink } from '../link/base-link';
import { TabNavigation } from './tab-navigation';
import { scrollTabIntoView, useTab } from './tab-util';
const BaseTab = (children, selectedTabId, styles, headerClass, tabPanelClassName, hideTabHeader, enableOverflowControls, forceUpdateTabs = false) => {
    const { selectTab, selectedTab } = useTab(selectedTabId, children);
    useEffect(() => {
        if (forceUpdateTabs) {
            selectTab(selectedTabId, false);
        }
    }, [forceUpdateTabs, selectTab, selectedTabId]);
    const tabHeader = ({ name, id, tooltipText = '', disabled = false, customHeader = null, onTabItemClick = _.noop, tabBottomBorder = false, tabSwitchable = true, }) => {
        const tabHeaderClass = cx(styles.headerItem, {
            [styles.headerItemSelected]: selectedTab === id,
            [styles.disabledTab]: disabled,
            [styles.borderBottom]: tabBottomBorder,
        });
        const handleClick = (event, tabId, isTabDisabled, isTabClicked) => {
            event.stopPropagation();
            if (isTabClicked) {
                selectTab(tabId, isTabDisabled);
                if (enableOverflowControls) {
                    scrollTabIntoView(tabId);
                }
            }
            if (!isTabDisabled) {
                onTabItemClick(event);
            }
        };
        return (React.createElement("li", { className: cx(tabHeaderClass, {
                [styles.headerNavItem]: enableOverflowControls,
            }), "data-tooltip-content": tooltipText, role: "tab", "aria-selected": selectedTab === id, key: id, tabIndex: 0, id: id, "data-testid": `tab-header-item-${id}`, onClick: (event) => handleClick(event, id, disabled, tabSwitchable), onKeyDown: getOnEnter((event) => handleClick(event, id, disabled, tabSwitchable)) },
            React.createElement(BaseLink, { className: cx(styles.headerText), "aria-controls": `section-${id}`, "aria-selected": selectedTab === id }, customHeader || name)));
    };
    const renderTabContent = () => React.Children.toArray(children).map((tabItem) => {
        /** reassigned children to child as children available on upper scope
         * to remove linting error
         */
        const { id, children: child } = tabItem.props;
        const tabContentClass = cx(tabPanelClassName, styles.tabPanel);
        return (React.createElement("section", { className: tabContentClass, "aria-hidden": !(selectedTab === id), key: id, id: `section-${id}`, "aria-labelledby": id }, child));
    });
    const renderTabItems = () => Children.toArray(children).map((tabItem) => tabHeader(tabItem.props));
    return (React.createElement(React.Fragment, null,
        !hideTabHeader &&
            (enableOverflowControls ? (React.createElement(TabNavigation, { headerClass: headerClass }, renderTabItems())) : (React.createElement("ul", { className: headerClass, role: "tablist" }, renderTabItems()))),
        renderTabContent()));
};
export { BaseTab };
//# sourceMappingURL=base-tab.js.map